import {
    CreditCard,
     Clock3,
    Wallet,
    Calendar,
    Receipt,
    IndianRupee,
    BadgeCheck,
    RotateCcw,
    Building2,
    Truck,
    Store,
} from "lucide-react";

import "./PaymentTab.css";

function PaymentTab({ order }) {

    const refund = order.refund || {};

    const paymentStatusClass =
        order.paymentStatus
            ?.toLowerCase()
            ?.replace(/\s+/g, "-");

    return (

        <div className="payment-tab">

            {/* ===========================================
                Payment Summary
            ============================================ */}

            <div className="payment-summary-card">

                <div className="payment-summary-header">

                    <div>

                        <h2>

                            Payment Summary

                        </h2>

                        <p>

                            Complete financial information
                            for this order.

                        </p>

                    </div>

                </div>

                <div className="payment-summary-grid">

                    {/* Payment Method */}

                    <div className="payment-summary-box">

                        <div className="summary-icon">

                            <Wallet size={24} />

                        </div>

                        <div>

                            <span>

                                Payment Method

                            </span>

                            <h3>

                                {order.paymentMethod || "-"}

                            </h3>

                        </div>

                    </div>

                    {/* Payment Status */}

                    <div className="payment-summary-box">

                        <div className="summary-icon">

                            <BadgeCheck size={24} />

                        </div>

                        <div>

                            <span>

                                Payment Status

                            </span>

                            <h3
                                className={`payment-status ${paymentStatusClass}`}
                            >

                                {order.paymentStatus}

                            </h3>

                        </div>

                    </div>

                    {/* Payment ID */}

                    <div className="payment-summary-box">

                        <div className="summary-icon">

                            <Receipt size={24} />

                        </div>

                        <div>

                            <span>

                                Payment ID

                            </span>

                            <h3>

                                {order.paymentId || "-"}

                            </h3>

                        </div>

                    </div>

                    {/* Ordered Date */}

                    <div className="payment-summary-box">

                        <div className="summary-icon">

                            <Calendar size={24} />

                        </div>

                        <div>

                            <span>

                                Ordered On

                            </span>

                            <h3>

                                {new Date(
                                    order.createdAt
                                ).toLocaleString("en-IN")}

                            </h3>

                        </div>

                    </div>

                </div>

            </div>

            {/* ===========================================
                Pricing Summary
                (Part 2)
            ============================================ */}

            {/* Continue in Part 2 */}
             {/* ===========================================
                Financial Breakdown
            ============================================ */}

            <div className="payment-breakdown-card">

                <div className="payment-card-header">

                    <IndianRupee size={22} />

                    <h2>

                        Financial Breakdown

                    </h2>

                </div>

                <table className="payment-breakdown-table">

                    <tbody>

                        <tr>

                            <td>Subtotal</td>

                            <td>

                                ₹{Number(
                                    order.subTotal || 0
                                ).toLocaleString("en-IN")}

                            </td>

                        </tr>

                        <tr>

                            <td>GST</td>

                            <td>

                                ₹{Number(
                                    order.gst || 0
                                ).toLocaleString("en-IN")}

                            </td>

                        </tr>

                        <tr>

                            <td>Packing Charge</td>

                            <td>

                                ₹{Number(
                                    order.packingCharge || 0
                                ).toLocaleString("en-IN")}

                            </td>

                        </tr>

                        <tr>

                            <td>Delivery Charge</td>

                            <td>

                                ₹{Number(
                                    order.deliveryCharge || 0
                                ).toLocaleString("en-IN")}

                            </td>

                        </tr>

                        <tr>

                            <td>Platform Fee</td>

                            <td>

                                ₹{Number(
                                    order.platformFee || 0
                                ).toLocaleString("en-IN")}

                            </td>

                        </tr>

                        <tr>

                            <td>Discount</td>

                            <td className="discount-text">

                                - ₹{Number(
                                    order.discount || 0
                                ).toLocaleString("en-IN")}

                            </td>

                        </tr>

                        <tr className="grand-total-row">

                            <td>

                                Grand Total

                            </td>

                            <td>

                                ₹{Number(
                                    order.grandTotal || 0
                                ).toLocaleString("en-IN")}

                            </td>

                        </tr>

                    </tbody>

                </table>

            </div>
            {/* ===========================================
                Earnings Distribution
            ============================================ */}

            <div className="earnings-card">

                <div className="payment-card-header">

                    <Store size={22} />

                    <h2>

                        Earnings Distribution

                    </h2>

                </div>

                <div className="earnings-grid">

                    {/* Provider */}

                    <div className="earning-box provider">

                        <div className="earning-icon">

                            <Store size={26} />

                        </div>

                        <div>

                            <span>

                                Provider Earnings

                            </span>

                            <h3>

                                ₹{Number(
                                    order.providerEarnings || 0
                                ).toLocaleString("en-IN")}

                            </h3>

                        </div>

                    </div>

                    {/* Delivery */}

                    <div className="earning-box delivery">

                        <div className="earning-icon">

                            <Truck size={26} />

                        </div>

                        <div>

                            <span>

                                Delivery Earnings

                            </span>

                            <h3>

                                ₹{Number(
                                    order.deliveryEarnings || 0
                                ).toLocaleString("en-IN")}

                            </h3>

                        </div>

                    </div>

                    {/* Platform */}

                    <div className="earning-box platform">

                        <div className="earning-icon">

                            <Building2 size={26} />

                        </div>

                        <div>

                            <span>

                                Platform Commission

                            </span>

                            <h3>

                                ₹{Number(
                                    order.platformCommission || 0
                                ).toLocaleString("en-IN")}

                            </h3>

                        </div>

                    </div>

                </div>

            </div>

             {/* ===========================================
                Refund Information
            ============================================ */}

            <div className="refund-card">

                <div className="payment-card-header">

                    <RotateCcw size={22} />

                    <h2>

                        Refund Information

                    </h2>

                </div>

                <div className="refund-grid">

                    {/* Refund Status */}

                    <div className="refund-box">

                        <RotateCcw size={24} />

                        <div>

                            <span>

                                Refund Status

                            </span>

                            <h3
                                className={
                                    refund.amount > 0
                                        ? "refund-success"
                                        : "refund-none"
                                }
                            >

                                {refund.amount > 0
                                    ? "Refunded"
                                    : "Not Refunded"}

                            </h3>

                        </div>

                    </div>

                    {/* Refund Amount */}

                    <div className="refund-box">

                        <IndianRupee size={24} />

                        <div>

                            <span>

                                Refund Amount

                            </span>

                            <h3>

                                ₹{Number(
                                    refund.amount || 0
                                ).toLocaleString("en-IN")}

                            </h3>

                        </div>

                    </div>

                    {/* Refund Reason */}

                    <div className="refund-box">

                        <Receipt size={24} />

                        <div>

                            <span>

                                Refund Reason

                            </span>

                            <h3>

                                {refund.reason || "-"}

                            </h3>

                        </div>

                    </div>

                    {/* Refund Date */}

                    <div className="refund-box">

                        <Calendar size={24} />

                        <div>

                            <span>

                                Refund Date

                            </span>

                            <h3>

                                {refund.refundedAt
                                    ? new Date(
                                          refund.refundedAt
                                      ).toLocaleString("en-IN")
                                    : "-"}

                            </h3>

                        </div>

                    </div>

                </div>

            </div>
            {/* ===========================================
                Payment Timeline
            ============================================ */}

            <div className="payment-timeline-card">

                <div className="payment-card-header">

                    <Clock3 size={22} />

                    <h2>

                        Financial Timeline

                    </h2>

                </div>

                <div className="timeline-list">

                    <div className="timeline-item">

                        <div className="timeline-dot completed"></div>

                        <div>

                            <h4>

                                Order Created

                            </h4>

                            <span>

                                {order.createdAt
                                    ? new Date(
                                          order.createdAt
                                      ).toLocaleString("en-IN")
                                    : "-"}

                            </span>

                        </div>

                    </div>

                    <div className="timeline-item">

                        <div
                            className={`timeline-dot ${
                                order.paymentStatus === "Paid"
                                    ? "completed"
                                    : "pending"
                            }`}
                        ></div>

                        <div>

                            <h4>

                                Payment Status

                            </h4>

                            <span>

                                {order.paymentStatus}

                            </span>

                        </div>

                    </div>

                    <div className="timeline-item">

                        <div
                            className={`timeline-dot ${
                                order.deliveredAt
                                    ? "completed"
                                    : "pending"
                            }`}
                        ></div>

                        <div>

                            <h4>

                                Order Delivered

                            </h4>

                            <span>

                                {order.deliveredAt
                                    ? new Date(
                                          order.deliveredAt
                                      ).toLocaleString("en-IN")
                                    : "Pending"}

                            </span>

                        </div>

                    </div>

                    <div className="timeline-item">

                        <div
                            className={`timeline-dot ${
                                refund.amount > 0
                                    ? "completed"
                                    : "pending"
                            }`}
                        ></div>

                        <div>

                            <h4>

                                Refund

                            </h4>

                            <span>

                                {refund.amount > 0
                                    ? "Refund Processed"
                                    : "No Refund"}

                            </span>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

}

export default PaymentTab;